import ChevronRight from "@mui/icons-material/ChevronRight";
import { Button, Tooltip } from "@mui/material";

/**
 * One lifecycle step's action: a small outlined button, disabled with its reason.
 *
 * Outlined rather than contained. The step marker beside it already says where
 * the shipment is, so a filled button would be a second, competing claim about
 * which move matters.
 */
export function StepAction({
  label,
  icon,
  endIcon,
  blocked,
  onClick,
}: {
  label: string;
  icon?: React.ReactElement;
  /**
   * Overrides the forward chevron. A chevron promises the shipment moves on;
   * an action that only opens something it already produced should not. Pass
   * null for an action that changes a fact about the step it sits under
   * without advancing anything.
   */
  endIcon?: React.ReactElement | null;
  /** Why the action cannot be taken, or "" when it can. */
  blocked: string;
  onClick: () => void;
}) {
  return (
    // The span is load-bearing: a disabled button fires no events, so the
    // tooltip has nothing to listen to without a wrapper that does.
    <Tooltip title={blocked}>
      <span>
        <Button
          variant="outlined"
          size="small"
          startIcon={icon}
          // Undefined means "not specified", so it takes the chevron; an
          // explicit null means "no end icon at all".
          endIcon={endIcon === undefined ? <ChevronRight /> : endIcon}
          onClick={onClick}
          disabled={Boolean(blocked)}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
